import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function Profile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUserProfile();
  }, []);

  const loadUserProfile = () => {
    api('/users/me').then(r => {
      if (r.ok) return r.json();
      return null;
    }).then(userData => {
      setUser(userData);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };

  const getUserNameFromCookie = () => {
    const match = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('displayName='));
    return match ? decodeURIComponent(match.split('=')[1]) : '';
  };

  const getTenantNameFromCookie = () => {
    const match = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('tenantName='));
    return match ? decodeURIComponent(match.split('=')[1]) : '';
  };

  if (loading) {
    return (
      <Layout>
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading profile...</p>
          </div>
        </div>
      </Layout>
    );
  }

  const displayName = getUserNameFromCookie();
  const tenantName = getTenantNameFromCookie();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Profile</h1>
          <p className="text-gray-600 mt-1">Your account information</p>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="px-6 py-4 bg-amber-50 border-b border-amber-100">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                {displayName ? displayName.charAt(0).toUpperCase() : 'U'}
              </div>
              <div className="ml-4">
                <h2 className="text-xl font-bold text-gray-900">{displayName || 'User'}</h2>
                <p className="text-gray-600">{tenantName || 'Organization'}</p>
              </div>
            </div>
          </div>

          <div className="px-6 py-4 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Display Name</label>
              <div className="px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900">
                {displayName || 'Not available'}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Organization</label>
              <div className="px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900">
                {tenantName || 'Not available'}
              </div>
            </div>

            {user && (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <div className="px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900">
                    {user.email || 'Not available'}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">User ID</label>
                  <div className="px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900 font-mono text-sm">
                    {user.id || 'Not available'}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Profile information is managed through the main application. 
              Contact your administrator for any changes.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}